import { Candidate, CandidateDescriptor } from '$synapse/models';
import { CandidateService } from '$synapse/services';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-candidate-creation-modal',
  templateUrl: './candidate-creation-modal.component.html',
  styleUrls: ['./candidate-creation-modal.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class CandidateCreationModalComponent {
  private readonly _candidateService = inject(CandidateService);
  private readonly _modalDisplay =
    inject<MatDialogRef<CandidateCreationModalComponent>>(MatDialogRef);
  private readonly _toastr = inject(ToastrService);

  candidate: CandidateDescriptor = new CandidateDescriptor(null, null, null);
  send = false;
  dateCondition = true;

  submit(): void {
    this.send = true;
    this._createCandidate().subscribe((result) => {
      if (result) {
        this._toastr.success(`Candidat créé avec succès`);
      } else {
        this._toastr.error(`Erreur rencontrée pendant la création du candidat`);
      }
      this._modalDisplay.close();
    });
  }

  private _createCandidate(): Observable<Candidate> {
    return this._candidateService.create(this.candidate);
  }
}
